import React, { useState } from "react"
import Icon from "../../../../lib/common/blocks/icon/Icon"
import * as MotherMenuStyles from "./MotherMenu.module.scss"
import Section from "../../main/section/Section"
import Button from "../../../../lib/common/blocks/button/Button"
import MotherMenuSearchForm from "./mother-menu-search/MotherMenuSearchForm"
const { sites } = require("../../../../../utils/site")

const MotherMenu = ({
  site,
  ismenuactive,
  searchTerm,
  triggerParentUpdateSearchTerm,
}) => {
  const [isSitesListActive, setSitesListActive] = useState(false)
  const toggleSitesList = () => {
    setSitesListActive(!isSitesListActive)
  }
  return (
    <Section
      className={`${MotherMenuStyles.mothermenu} ${
        ismenuactive ? MotherMenuStyles.active : ""
      }`}
      container="xlarge flex align-items-center"
    >
      <div className={MotherMenuStyles.grid}>
        <div className={"xs-none lg-flex"}>
          {(site === "gc" || site === "com") && (
            <div className={`buttons ${MotherMenuStyles.toggleSwitchButtons}`}>
              <Button
                aspect={"unstyled"}
                href={sites["com"].baseUrl}
                className={`${MotherMenuStyles.toggleSwitchButton} ${
                  site === "com" ? MotherMenuStyles.active : ""
                }`}
              >
                Professionnel
              </Button>
              <Button
                aspect={"unstyled"}
                href={sites["gc"].baseUrl}
                className={`${MotherMenuStyles.toggleSwitchButton} ${
                  site === "gc" ? MotherMenuStyles.active : ""
                }`}
              >
                Entreprise
              </Button>
            </div>
          )}
        </div>
        <nav className={MotherMenuStyles.menu}>
          {ismenuactive && (
            <Button
              aspect="unstyled"
              onClick={toggleSitesList}
              className={MotherMenuStyles.sitesButton}
            >
              Nos Sites
              <Icon icon={isSitesListActive ? "arrowDown" : "arrowUp"} />
            </Button>
          )}
          <ul
            className={`${MotherMenuStyles.sitesList} ${
              isSitesListActive ? MotherMenuStyles.active : ""
            }`}
          >
            {(!(site === "gc" || site === "com") ||
              (ismenuactive && (site === "gc" || site === "com"))) && (
              <>
                <li>
                  <Button
                    aspect={"unstyled"}
                    href={sites["com"].baseUrl}
                    className={site === "com" ? MotherMenuStyles.active : ""}
                  >
                    Offres pros
                  </Button>
                </li>
                <li>
                  <Button
                    aspect={"unstyled"}
                    href={sites["gc"].baseUrl}
                    className={site === "gc" ? MotherMenuStyles.active : ""}
                  >
                    Offres entreprises
                  </Button>
                </li>
              </>
            )}
            <li>
              <Button
                aspect={"unstyled"}
                href={sites["grp"].baseUrl}
                className={site === "grp" ? MotherMenuStyles.active : ""}
              >
                Groupe
              </Button>
            </li>
            <li>
              <Button
                aspect={"unstyled"}
                href={sites["rh"].baseUrl}
                className={site === "rh" ? MotherMenuStyles.active : ""}
              >
                Recrutement
              </Button>
            </li>
            <li>
              <Button
                aspect={"unstyled"}
                href={sites["blog"].baseUrl}
                className={site === "blog" ? MotherMenuStyles.active : ""}
              >
                Blog
              </Button>
            </li>
          </ul>
        </nav>
        <nav className={MotherMenuStyles.icons}>
          <ul
            className={`${MotherMenuStyles.iconsList} ${
              isSitesListActive ? MotherMenuStyles.active : ""
            }`}
          >
            {site === "com" && (
              <li className="hidden">
                <Button
                  aspect="unstyled"
                  to="/faq"
                  activeclassname={MotherMenuStyles.active}
                >
                  <Icon
                    icon="question"
                    className="xs-none lg-block"
                  />
                  <span className={`${MotherMenuStyles.text} lg-none`}>
                    FAQ
                  </span>
                </Button>
              </li>
            )}
            {(() => {
              switch (site) {
                case "gc":
                case "com":
                  return (
                    <li>
                      <MotherMenuSearchForm
                        site={site}
                        searchTerm={searchTerm}
                        triggerParentUpdateSearchTerm={
                          triggerParentUpdateSearchTerm
                        }
                      />
                    </li>
                  )
                default:
                  return null
              }
            })()}
            {site !== "rh" && (
              <>
                <li>
                  <Button
                    aspect="unstyled"
                    href={sites.sl.baseUrl}
                  >
                    <Icon
                      icon="geo"
                      className="xs-none lg-block"
                    />
                    <span className={`${MotherMenuStyles.text} lg-none`}>
                      Mon agence
                    </span>
                  </Button>
                </li>
                <li>
                  <Button
                    aspect="unstyled"
                    href="https://espaceclients.paritel.fr/"
                    activeclassname={MotherMenuStyles.active}
                  >
                    <Icon
                      icon="info"
                      className="xs-none lg-block"
                    />
                    <span className={`${MotherMenuStyles.text} lg-none`}>
                      Se connecter
                    </span>
                  </Button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </Section>
  )
}

export default MotherMenu
